import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IModalComponent } from '@lib/modal';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HcService } from '@project/services';

@Component({
  selector: 'lib-doctor-confirmation',
  templateUrl: './doctor-confirmation.html',
  styleUrls: ['./doctor-confirmation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoctorConfirmation implements IModalComponent {
  @Input() message: string = null;

  @Output() readonly close$ = new EventEmitter();
  @Output() readonly submit$ = new EventEmitter();

  public isPublicHc = this.hcService.getHcConfig().isPublic;

  public form = new FormGroup({
    keepAttendance: new FormControl(false),
    changeHc: new FormControl(false),
    takeBreak: new FormControl(false),
  });

  constructor(private hcService: HcService) {}

  onCheckboxChange(checkBoxName: string) {
    const controls = this.form.controls;
    Object.keys(controls).forEach((key) => {
      if (key !== checkBoxName) {
        controls[key].setValue(false, { emitEvent: false });
      }
    });
  }

  confirm() {
    this.submit$.emit(this.form.value);
  }

  cancel() {
    this.submit$.emit(false);
    this.close$.emit();
  }
}
